module.exports = __webpack_public_path__ + "img/truck_01.c44079e7.jpg";